"use client";

import { SiteHero, Ladder, SplitRow, CheckList, SectionHead, FullBleedPhoto, FaqList, CtaBand, RelatedLinks } from "@/components/marketing/site-ui";
import { MatchScoreMock } from "@/components/marketing/site-mocks";
import { useSiteContent } from "@/components/marketing/use-site-content";

export function DiscoverClient() {
  const c = useSiteContent();
  const page = c.discoverPage;

  return (
    <>
      <SiteHero
        eyebrow={page.eyebrow}
        title={page.title}
        lede={page.lede}
        primaryLabel={page.primary}
        note={page.note}
        aside={<MatchScoreMock />}
      />

      <section className="border-y border-neutral-200 bg-white py-14 md:py-20">
        <div className="gs-page">
          <Ladder steps={page.ladder} />
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="gs-page">
          <SectionHead eyebrow={page.howEyebrow} title={page.howTitle} body={page.howBody} />
          <div className="mt-9 grid gap-x-12 gap-y-4 lg:grid-cols-2">
            <CheckList items={page.howItems.slice(0, 3)} />
            <CheckList items={page.howItems.slice(3)} />
          </div>
        </div>
      </section>

      <FullBleedPhoto
        src="/images/discover-first-meeting.webp"
        alt={page.photoAlt}
        eyebrow={page.photoEyebrow}
        title={page.photoTitle}
        body={page.photoBody}
      />

      <section className="border-b border-neutral-200 bg-white py-16 md:py-24">
        <div className="gs-page">
          <SplitRow
            eyebrow={page.consentEyebrow}
            title={page.consentTitle}
            body={page.consentBody}
            items={page.consentItems}
            flip
            aside={
              /* One number, at display size, doing the work a third card would have done
                 badly. The claim is unusual enough to be worth stating on its own. */
              <div className="rounded-[1.75rem] border border-neutral-200 bg-[#fafafa] p-8 md:p-12">
                <p className="gs-display leading-none text-neutral-900">{page.consentStat}</p>
                <p className="mt-4 max-w-[24ch] text-balance text-xl font-bold leading-snug tracking-[-0.02em] text-neutral-900">
                  {page.consentStatLabel}
                </p>
                <p className="mt-3 max-w-[34ch] text-[15px] leading-relaxed text-neutral-600">{page.consentStatNote}</p>
              </div>
            }
          />
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="gs-page">
          {/* The measure goes on an inner box: .gs-page centres, so a narrower max-width on it
              would recentre this section and move the page's left edge. */}
          <div className="max-w-4xl">
            <FaqList heading={c.common.faqHeading} items={page.faq} />
          </div>
        </div>
      </section>

      <RelatedLinks
        links={[
          { href: "/features/events", title: c.features.events.name, body: c.features.events.tagline },
          { href: "/features/opportunities", title: c.features.opportunities.name, body: c.features.opportunities.tagline },
          { href: "/pricing", title: c.nav.pricing, body: c.pricingPage.short },
        ]}
      />

      <div className="pt-14 md:pt-20">
        <CtaBand />
      </div>
    </>
  );
}
